<template>

    <div id="head">
        <div class="bannerBox">
            <div class="logo">
                <img src="../../assets/images/logo.png" width="400">
            </div>
            <img class="logoBj" src="../../assets/images/head-top_banner.png">
        </div>

        <div id="nav" v-if='!isNavShow'>
            <ul class="navList">
                <li v-for="(item, index) in navListData" :key='index'
                    :class="[{'active': index == isActive },idClass(item.routerPath.newsId?item.routerPath.newsId:item.routerPath.id)]" @click='toggle(index)'>
                    <span>{{item.title}}</span>
                    <!-- <router-link :to="item.routerPath">{{item.title}}</router-link>-->
                </li>
            </ul>
        </div>
    </div>
</template>

<script>
export default {
    computed: {
        idClass () {
            return function (param) {
                if (param) {
                    return 'list' + param;
                }
            }
        }
    },
    props: {
        activeNavIdx: {
            type: Number,
            default: 0
        },
        isNavShow: {
            type: Boolean
        },
    },
    data () {
        return {
            isActive: 0,
            navListData: [
                {
                    'title': '首页',
                    'routerPath': { path: '/' }
                },
              /*
                {
                    'title': '协会介绍',
                    'routerPath': { path: '/associationIntroduce' }
                },
                */
                {
                    'title': '协会动态',
                    'routerPath': {
                        path: '/newsList',
                        newsId: '1'
                    }
                },
                {
                    'title': '办事指南',
                    'routerPath': {
                        path: '/newsList',
                        newsId: '2'
                    }
                },
                {
                    'title': '继续教育',
                    'routerPath': {
                        path: '/newsList',
                        newsId: '3'
                    }
                },
                {
                    'title': '新闻资讯',
                    'routerPath': {
                        path: '/newsList',
                        newsId: '4'
                    }
                },
                {
                    'title': '药学服务',
                    'routerPath': {
                        path: '/newsList',
                        newsId: '5'
                    }
                },
                {
                    'title': '联系我们',
                    'routerPath': { path: '/contactUs' }
                },
            ]
        }
    },
    created () {
        this.isActive = this.$route.query.currentNavIdx || this.activeNavIdx || 0;


        let sessionNavCategory = sessionStorage.getItem('navCategory');
        var sessionExpirationTime=sessionStorage.getItem('expirationTime');
        var nowTime = new Date().getTime()
        if (sessionNavCategory && nowTime < sessionExpirationTime) {
            this.paixu(JSON.parse(sessionNavCategory));
           // this.initNavCategory();
        } else {
           this.initNavCategory();

        }
    },
    mounted () {
    },
    methods: {
        /**
         * 导航跳转
         */
        toggle (idx) {
            this.isActive = idx;
            let newsId = this.navListData[idx].routerPath.newsId;
            let id=this.navListData[idx].routerPath.id;
            if (newsId) {
                this.$router.push({
                    path: this.navListData[idx].routerPath.path,
                    query: {
                        newsId: newsId,
                        currentNavIdx: idx
                    }
                });
                this.$emit('getNewsId', newsId);
            }else if(!newsId && id){
              this.$router.push({
                  path: this.navListData[idx].routerPath.path,
                  query: {
                      api:'education',
                      id: id,
                      currentNavIdx: idx
                  }
              });
            } else {
                this.$router.push({ path: this.navListData[idx].routerPath.path })
            }
        },
        /**
         * 获取导航顺序
         */
        initNavCategory () {

            this.$store.dispatch('navCategory', {}).then((res) => {
                if (res.code == 200) {

                    let navCategoryData = res.data;

                    //删除通知公告
                    navCategoryData = navCategoryData.filter(item => item.id != 6)
                    console.log(navCategoryData)
                    //排序
                    this.paixu(navCategoryData)
                    sessionStorage.setItem('navCategory', JSON.stringify(navCategoryData));
                    var expirationTime=new Date().getTime()+3600*24*100
                    sessionStorage.setItem('expirationTime', expirationTime);

                }
            }).catch(error => {
                console.log('catch====', error)
            })
        },
        /**
         * 排序
         */
        paixu (list) {
            for (var i = 0; i < list.length; i++) {
              if(list[i].type==1){
                this.navListData.splice(i + 1, 1, {
                    'title': list[i].name,
                    'routerPath': {
                        path: '/newsList',
                        newsId: list[i].id
                    }
                });
              }else if(list[i].type==2){
                this.navListData.splice(i + 1, 1, {
                    'title': list[i].name,
                    'routerPath': {
                        path: '/newDetail',
                        id: list[i].id
                    }
                });
              }

            }


            let id = this.$route.query.newsId;
            let obj = {
                '1':'协会动态',
                '2':'办事指南',
                '3':'继续教育',
                '4':'新闻资讯',
                '5':'药学服务',
                '21':'党群工作',
                '22':'会员风采',
                '24':'协会介绍',
                '25':'会员入口'
            }
            //  this.$route.query.newsId;

            let flg = obj[id];

            if( this.$route.query.newsId ){
                this.navListData.map((item,index)=>{
                    if( item.title == flg ){
                        this.isActive = index;
                    }
                })
            }
            // this.isActive =
        },

        /**
         * 获取地址栏参数
         */
        getQueryVariable (variable) {
            var reg = window.location.href.split('?')[1].split('&');
            var obj = {};
            for (var i in reg) {
                let key = reg[i].split('=');
                obj[key[0]] = key[1];
            }
            return obj[variable];
        }

    }
}
</script>

<style scoped>
@media (min-width: 1399px) {
    .bannerBox .logo {
        width: 1200px;
        margin: auto;
    }
}

.bannerBox {
    position: relative;
}
.bannerBox .logo {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    margin: auto;
}
.bannerBox .logo img {
    position: absolute;
    top: 0;
    bottom: 0;
    margin: auto;
}
.bannerBox .logoBj {
    width: 100%;
    vertical-align: middle;
}
.topBanner {
    width: 100%;
    display: block;
}

#nav {
    background-image: -webkit-linear-gradient(top, #0173ff, #6babfa);
    background-image: -o-linear-gradient(top, #0173ff, #6babfa);
    background-image: -ms-linear-gradient(top, #0173ff, #6babfa);
    background-image: linear-gradient(top, #0173ff, #6babfa);
    text-align: center;
    height: 100px;
    overflow: hidden;
}

.navList {
    width: 1200px;
    overflow: hidden;
    display: flex;
    margin: auto;
}

.navList li {
    flex: 1;
    height: 100px;
    line-height: 140px;
    color: #fff;
    padding: 0 30px;
    cursor: pointer;
}

.navList li:first-child {
    padding: 0 46px;
}

.navList li.active {
    background: #b0d0fd;
}
.navList li span {
    display: block;
}
.navList li a {
    color: #fff;
}

.navList li:nth-child(1) span {
    background: url("../../assets/images/nav_index_icon.png") no-repeat center
        21px;
    background-size: 30px auto;
}
/*
.navList li:nth-child(2) span {
    background: url("../../assets/images/nav_xiehuijieshao_icon.png") no-repeat
        center 21px;
    background-size: 25px auto;
}
*/

.navList li.list1 span {
    background: url("../../assets/images/nav_xiehuidongtai_icon.png") no-repeat
        center 21px;
    background-size: 30px auto;
}

.navList li.list2 span {
    background: url("../../assets/images/nav_banshizhinan_icon.png") no-repeat
        center 21px;
    background-size: 27px auto;
}

.navList li.list3 span {
    background: url("../../assets/images/nav_jixujiaoyu_icon.png") no-repeat
        center 21px;
    background-size: 30px auto;
}

.navList li.list4 span {
    background: url("../../assets/images/nav_xinwenzixun_icon.png") no-repeat
        center 23px;
    background-size: 30px auto;
}

.navList li.list5 span {
    background: url("../../assets/images/nav_yaoxuefuwu_icon.png") no-repeat
        center 25px;
    background-size: 33px auto;
}

.navList li.list21 span {
    background: url("../../assets/images/nav_dangqungongzuo_icon2.png") no-repeat
        center 25px;
    background-size: 33px auto;
}

.navList li.list22 span,.navList li.list558 span  {
    background: url("../../assets/images/nav_huiyuanfengcai_icon.png") no-repeat
        center 21px;
    background-size: 30px auto;
}

.navList li.list24 span{
  background: url("../../assets/images/nav_xiehuijieshao_icon.png") no-repeat
      center 21px;
  background-size: 25px auto;
}

/* .navList li:nth-child(1).active {
    background:url('../../assets/images/nav_index_icon.png') no-repeat  center 21px #b0d0fd;
    background-size:30px auto;
}


.navList li.active  .navList li:nth-child(2) {
    background:url('../../assets/images/nav_index_icon.png') no-repeat  center 21px #b0d0fd;
    background-size:30px auto;
}
 */
</style>



// WEBPACK FOOTER //
// src/components/common/commonHeader.vue